export default () => ({
  generalAttributes: {
    display: 'flex',
    flexDirection: 'column',
  },
  subheading: {
    color: '#7C7C80',
    fontSize: '18px',
    fontWeight: '500',
    textTransform: 'uppercase',
    margin: '10px 0',
  },
  sectionRow: {
    display: 'flex',
    alignItems: 'center',
  },
  formLabel: {
    width: 60,
    marginRight: 10,
  },
  input: {
    width: 50,
  },
});
